import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/305'

const FirstPurchasersAndActivationsPerLocationPerMonthTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="activation_rate.tabs.first_purchasers_and_activations_per_location_per_month"
  />
)

export default FirstPurchasersAndActivationsPerLocationPerMonthTab
